import React, { Component } from 'react';
import { table_data } from 'variables/Variables.jsx';

// var mapData = {
//     AU: 760,
//     BR: 550,
//     CA: 120,
//     DE: 1300,
//     FR: 540,
//     GB: 690,
//     GE: 200,
//     IN: 200,
//     RO: 600,
//     RU: 300,
//     US: 2920
// };

class Dashboard extends Component {
    createTableData() {
        var tableRows = [];
        for (var i = 0; i < table_data.length; i++) {
            tableRows.push(
                <tr key={i}>
                    <td>
                        <div className="flag">
                            <img src={table_data[i].flag} alt="us_flag" />
                        </div>
                    </td>
                    <td>{table_data[i].country}</td>
                    <td className="text-right">{table_data[i].count}</td>
                    <td className="text-right">{table_data[i].percentage}</td>
                </tr>
            );
        }
        return tableRows;
    }
    render() {
        return (
            <div className="main-content" style={{ textAlign: 'center' }}>
                <h3>Bienvenido</h3>
            </div>
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx